
import { FoodItem } from './types';

// Expanded default USDA foods list with even more options
export const getDefaultUsdaFoods = (): FoodItem[] => {
  const usdaFoods = [
    // Basic foods
    { name: 'Manzana', calories: 52, protein: 0.3, carbs: 14, fat: 0.2 },
    { name: 'Plátano', calories: 89, protein: 1.1, carbs: 23, fat: 0.3 },
    { name: 'Arroz blanco', calories: 130, protein: 2.7, carbs: 28, fat: 0.3 },
    { name: 'Frijoles', calories: 127, protein: 8.7, carbs: 22.8, fat: 0.5 },
    { name: 'Leche de almendra', calories: 15, protein: 0.5, carbs: 0.3, fat: 1.1 },
    { name: 'Tomate', calories: 18, protein: 0.9, carbs: 3.9, fat: 0.2 },
    { name: 'Aguacate', calories: 160, protein: 2, carbs: 8.5, fat: 14.7 },
    { name: 'Patata', calories: 77, protein: 2, carbs: 17, fat: 0.1 },
    { name: 'Brócoli', calories: 34, protein: 2.8, carbs: 6.6, fat: 0.4 },
    { name: 'Quinoa', calories: 120, protein: 4.4, carbs: 21, fat: 1.9 },
    
    // Grains and cereals
    { name: 'Maíz dulce', calories: 86, protein: 3.2, carbs: 19, fat: 1.2 },
    { name: 'Maíz en grano', calories: 365, protein: 9.4, carbs: 74, fat: 4.7 },
    { name: 'Harina de maíz', calories: 370, protein: 8, carbs: 77, fat: 3.9 },
    { name: 'Palomitas de maíz', calories: 375, protein: 12, carbs: 74, fat: 4.3 },
    { name: 'Tortitas de maíz', calories: 237, protein: 4.5, carbs: 48, fat: 2.2 },
    { name: 'Arroz integral', calories: 111, protein: 2.6, carbs: 23, fat: 0.9 },
    { name: 'Arroz basmati', calories: 121, protein: 2.7, carbs: 25.2, fat: 0.6 },
    { name: 'Arroz salvaje', calories: 101, protein: 4, carbs: 21, fat: 0.3 },
    { name: 'Avena', calories: 389, protein: 16.9, carbs: 66.3, fat: 6.9 },
    { name: 'Copos de avena', calories: 379, protein: 13.2, carbs: 67.7, fat: 6.5 },
    { name: 'Harina de trigo integral', calories: 340, protein: 13.2, carbs: 72, fat: 2.5 },
    { name: 'Cuscús', calories: 376, protein: 12.8, carbs: 77.4, fat: 0.6 },
    { name: 'Bulgur', calories: 342, protein: 12.3, carbs: 75.9, fat: 1.3 },
    { name: 'Pasta integral', calories: 353, protein: 12, carbs: 71.1, fat: 2.5 },
    { name: 'Espaguetis', calories: 371, protein: 13, carbs: 75, fat: 1.5 },
    
    // Chocolate and cacao products
    { name: 'Cacao en polvo puro', calories: 228, protein: 19.6, carbs: 57.9, fat: 13.7 },
    { name: 'Cacao en polvo sin azúcar', calories: 235, protein: 20, carbs: 34, fat: 11 },
    { name: 'Cacao en polvo con azúcar', calories: 340, protein: 7, carbs: 80, fat: 3.5 },
    { name: 'Chocolate negro 50%', calories: 550, protein: 5.5, carbs: 59, fat: 31 },
    { name: 'Chocolate negro 70%', calories: 598, protein: 7.8, carbs: 45.9, fat: 43 },
    { name: 'Chocolate negro 85%', calories: 630, protein: 10.5, carbs: 31, fat: 53 },
    { name: 'Chocolate negro 90%', calories: 647, protein: 11.5, carbs: 19, fat: 59 },
    { name: 'Chocolate negro 99%', calories: 660, protein: 13, carbs: 8, fat: 65 },
    { name: 'Chocolate con leche', calories: 535, protein: 7.7, carbs: 59.4, fat: 30 },
    { name: 'Chocolate blanco', calories: 539, protein: 5.9, carbs: 59, fat: 32.1 },
    { name: 'Nibs de cacao', calories: 350, protein: 9, carbs: 34, fat: 30 },
    { name: 'Manteca de cacao', calories: 884, protein: 0, carbs: 0, fat: 100 },
    { name: 'Pasta de cacao', calories: 570, protein: 14, carbs: 30, fat: 50 },
    
    // Legumes
    { name: 'Lentejas', calories: 116, protein: 9, carbs: 20, fat: 0.4 },
    { name: 'Lentejas rojas', calories: 330, protein: 24.6, carbs: 56, fat: 1.8 },
    { name: 'Lentejas verdes', calories: 340, protein: 25, carbs: 63, fat: 1.1 },
    { name: 'Garbanzos', calories: 164, protein: 8.9, carbs: 27, fat: 2.6 },
    { name: 'Garbanzos cocidos', calories: 119, protein: 6.2, carbs: 21, fat: 2 },
    { name: 'Judías blancas', calories: 139, protein: 8.7, carbs: 25, fat: 0.6 },
    { name: 'Judías negras', calories: 132, protein: 8.9, carbs: 23.7, fat: 0.5 },
    { name: 'Judías pintas', calories: 143, protein: 9, carbs: 26, fat: 0.7 },
    { name: 'Soja', calories: 446, protein: 36.5, carbs: 30.2, fat: 19.9 },
    { name: 'Edamame', calories: 121, protein: 11, carbs: 13, fat: 5 },
    { name: 'Habas', calories: 341, protein: 26, carbs: 58, fat: 1.5 },
    { name: 'Guisantes', calories: 81, protein: 5, carbs: 14, fat: 0.4 },
    { name: 'Guisantes secos', calories: 352, protein: 23.8, carbs: 63, fat: 1.2 },
    
    // Greens and vegetables
    { name: 'Espinacas', calories: 23, protein: 2.9, carbs: 3.6, fat: 0.4 },
    { name: 'Kale', calories: 49, protein: 4.3, carbs: 8.8, fat: 0.9 },
    { name: 'Acelgas', calories: 19, protein: 1.8, carbs: 3.7, fat: 0.2 },
    { name: 'Lechuga Romana', calories: 17, protein: 1.2, carbs: 3.3, fat: 0.3 },
    { name: 'Lechuga Iceberg', calories: 14, protein: 0.9, carbs: 3, fat: 0.1 },
    { name: 'Rúcula', calories: 25, protein: 2.6, carbs: 3.7, fat: 0.7 },
    { name: 'Canónigos', calories: 21, protein: 2, carbs: 3.8, fat: 0.4 },
    { name: 'Repollo', calories: 25, protein: 1.3, carbs: 5.8, fat: 0.1 },
    { name: 'Col rizada', calories: 32, protein: 3.3, carbs: 6.7, fat: 0.7 },
    { name: 'Brotes de soja', calories: 31, protein: 3, carbs: 5.9, fat: 0.2 },
    { name: 'Zanahoria', calories: 41, protein: 0.9, carbs: 9.6, fat: 0.2 },
    { name: 'Batata', calories: 86, protein: 1.6, carbs: 20.1, fat: 0.1 },
    { name: 'Puerro', calories: 61, protein: 1.5, carbs: 14, fat: 0.3 },
    { name: 'Apio', calories: 16, protein: 0.7, carbs: 3, fat: 0.2 },
    { name: 'Calabaza', calories: 26, protein: 1, carbs: 6.5, fat: 0.1 },
    { name: 'Calabacín', calories: 17, protein: 1.2, carbs: 3.1, fat: 0.3 },
    { name: 'Pepino', calories: 15, protein: 0.7, carbs: 3.6, fat: 0.1 },
    { name: 'Berenjena', calories: 25, protein: 1, carbs: 6, fat: 0.2 },
    { name: 'Pimiento rojo', calories: 31, protein: 1, carbs: 6, fat: 0.3 },
    { name: 'Pimiento verde', calories: 20, protein: 0.9, carbs: 4.6, fat: 0.2 },
    { name: 'Ajo', calories: 149, protein: 6.4, carbs: 33.1, fat: 0.5 },
    { name: 'Cebolla', calories: 40, protein: 1.1, carbs: 9.3, fat: 0.1 },
    { name: 'Champiñones', calories: 22, protein: 3.1, carbs: 3.3, fat: 0.3 },
    { name: 'Alcachofa', calories: 47, protein: 3.3, carbs: 10, fat: 0.2 },
    { name: 'Espárragos', calories: 20, protein: 2.2, carbs: 3.9, fat: 0.2 },
    { name: 'Remolacha', calories: 43, protein: 1.6, carbs: 9.6, fat: 0.2 },
    { name: 'Coliflor', calories: 25, protein: 1.9, carbs: 5, fat: 0.1 },
    { name: 'Coles de Bruselas', calories: 43, protein: 3.4, carbs: 9, fat: 0.3 },
    { name: 'Rábano', calories: 16, protein: 0.7, carbs: 3.4, fat: 0.1 },
    { name: 'Nabo', calories: 28, protein: 0.9, carbs: 6.4, fat: 0.1 },
    
    // Nuts and seeds
    { name: 'Almendras', calories: 579, protein: 21.2, carbs: 21.7, fat: 49.4 },
    { name: 'Nueces', calories: 654, protein: 15.2, carbs: 13.7, fat: 65.2 },
    { name: 'Anacardos', calories: 553, protein: 18, carbs: 30.2, fat: 43.8 },
    { name: 'Avellanas', calories: 628, protein: 15, carbs: 17, fat: 60.8 },
    { name: 'Pistachos', calories: 560, protein: 20, carbs: 28, fat: 45 },
    { name: 'Nueces de Brasil', calories: 656, protein: 14.3, carbs: 12, fat: 67 },
    { name: 'Piñones', calories: 673, protein: 13.7, carbs: 13.1, fat: 68.4 },
    { name: 'Nueces de Macadamia', calories: 718, protein: 7.9, carbs: 13.8, fat: 75.8 },
    { name: 'Semillas de chía', calories: 486, protein: 16.5, carbs: 42, fat: 30.7 },
    { name: 'Semillas de lino', calories: 534, protein: 18.3, carbs: 28.9, fat: 42.2 },
    { name: 'Semillas de calabaza', calories: 559, protein: 30.2, carbs: 10.7, fat: 49 },
    { name: 'Semillas de girasol', calories: 584, protein: 20, carbs: 20, fat: 51.5 },
    { name: 'Semillas de sésamo', calories: 573, protein: 17.7, carbs: 23.4, fat: 49.7 },
    { name: 'Tahini (pasta de sésamo)', calories: 595, protein: 17, carbs: 21.2, fat: 53 },
    { name: 'Mantequilla de cacahuete', calories: 588, protein: 25, carbs: 20, fat: 50 },
    { name: 'Mantequilla de almendra', calories: 614, protein: 21, carbs: 19.5, fat: 54 },
    
    // Plant-based proteins
    { name: 'Tofu firme', calories: 144, protein: 15.9, carbs: 3.3, fat: 8.7 },
    { name: 'Tofu sedoso', calories: 61, protein: 4.8, carbs: 2.9, fat: 3.5 },
    { name: 'Tempeh', calories: 193, protein: 20.3, carbs: 7.6, fat: 10.8 },
    { name: 'Seitan', calories: 370, protein: 75, carbs: 13, fat: 1.9 },
    { name: 'Proteína de soja texturizada', calories: 339, protein: 50, carbs: 30, fat: 1 },
    { name: 'Proteína de guisante', calories: 391, protein: 80, carbs: 7, fat: 7 },
    { name: 'Proteína de arroz', calories: 366, protein: 80, carbs: 7, fat: 3 },
    { name: 'Levadura nutricional', calories: 325, protein: 40, carbs: 39, fat: 4 },
    { name: 'Hummus', calories: 166, protein: 7.9, carbs: 14.3, fat: 9.6 },
    { name: 'Falafel', calories: 333, protein: 13.3, carbs: 31.8, fat: 17.8 },
    
    // Plant-based dairy alternatives
    { name: 'Leche de soja', calories: 33, protein: 3.2, carbs: 1.8, fat: 1.9 },
    { name: 'Yogur de soja', calories: 61, protein: 3.5, carbs: 4.5, fat: 3.2 },
    { name: 'Leche de avena', calories: 40, protein: 1, carbs: 6.5, fat: 1.5 },
    { name: 'Leche de coco', calories: 230, protein: 2.3, carbs: 6.7, fat: 24 },
    { name: 'Leche de arroz', calories: 47, protein: 0.3, carbs: 9.2, fat: 1 },
    { name: 'Queso vegano', calories: 321, protein: 5, carbs: 28, fat: 22 },
    { name: 'Yogur de coco', calories: 98, protein: 0.5, carbs: 10, fat: 6 },
    { name: 'Nata vegetal', calories: 279, protein: 1.7, carbs: 9, fat: 27 },
    { name: 'Mantequilla vegetal', calories: 717, protein: 0, carbs: 0, fat: 80 },
    
    // Fruits
    { name: 'Arándanos', calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    { name: 'Fresas', calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    { name: 'Frambuesas', calories: 52, protein: 1.2, carbs: 11.9, fat: 0.7 },
    { name: 'Moras', calories: 43, protein: 1.4, carbs: 9.6, fat: 0.5 },
    { name: 'Arándanos rojos', calories: 46, protein: 0.4, carbs: 12, fat: 0.1 },
    { name: 'Cerezas', calories: 63, protein: 1.1, carbs: 16, fat: 0.2 },
    { name: 'Kiwi', calories: 61, protein: 1.1, carbs: 14.7, fat: 0.5 },
    { name: 'Pera', calories: 57, protein: 0.4, carbs: 15, fat: 0.1 },
    { name: 'Naranja', calories: 43, protein: 0.9, carbs: 8.3, fat: 0.1 },
    { name: 'Limón', calories: 29, protein: 1.1, carbs: 9.3, fat: 0.3 },
    { name: 'Lima', calories: 30, protein: 0.7, carbs: 10.5, fat: 0.2 },
    { name: 'Pomelo', calories: 42, protein: 0.8, carbs: 10.7, fat: 0.1 },
    { name: 'Mandarina', calories: 53, protein: 0.8, carbs: 13.3, fat: 0.3 },
    { name: 'Uvas', calories: 67, protein: 0.6, carbs: 17.2, fat: 0.4 },
    { name: 'Mango', calories: 60, protein: 0.8, carbs: 15, fat: 0.4 },
    { name: 'Piña', calories: 50, protein: 0.5, carbs: 13.1, fat: 0.1 },
    { name: 'Papaya', calories: 43, protein: 0.5, carbs: 10.8, fat: 0.3 },
    { name: 'Melocotón', calories: 39, protein: 0.9, carbs: 9.5, fat: 0.3 },
    { name: 'Nectarina', calories: 44, protein: 1.1, carbs: 10.6, fat: 0.3 },
    { name: 'Albaricoque', calories: 48, protein: 1.4, carbs: 11.1, fat: 0.4 },
    { name: 'Ciruela', calories: 46, protein: 0.7, carbs: 11.4, fat: 0.3 },
    { name: 'Sandía', calories: 30, protein: 0.6, carbs: 7.6, fat: 0.2 },
    { name: 'Melón', calories: 34, protein: 0.8, carbs: 8, fat: 0.2 },
    { name: 'Higos', calories: 74, protein: 0.8, carbs: 19.2, fat: 0.3 },
    { name: 'Dátiles', calories: 282, protein: 2.5, carbs: 75, fat: 0.4 },
    { name: 'Pasas', calories: 299, protein: 3.1, carbs: 79.2, fat: 0.5 },
    { name: 'Ciruelas pasas', calories: 240, protein: 2.2, carbs: 63.9, fat: 0.4 },
    { name: 'Orejones de albaricoque', calories: 241, protein: 3.4, carbs: 62.6, fat: 0.5 },
    
    // Oils and fats
    { name: 'Aceite de oliva', calories: 884, protein: 0, carbs: 0, fat: 100 },
    { name: 'Aceite de coco', calories: 862, protein: 0, carbs: 0, fat: 100 },
    { name: 'Aceite de girasol', calories: 884, protein: 0, carbs: 0, fat: 100 },
    { name: 'Aceite de lino', calories: 884, protein: 0, carbs: 0, fat: 100 },
    { name: 'Aceite de sésamo', calories: 884, protein: 0, carbs: 0, fat: 100 },
    { name: 'Aceite de aguacate', calories: 884, protein: 0, carbs: 0, fat: 100 },
    { name: 'Aceitunas verdes', calories: 145, protein: 1, carbs: 3.8, fat: 15.3 },
    { name: 'Aceitunas negras', calories: 115, protein: 0.8, carbs: 6, fat: 11 },
    
    // Baked goods and cereals
    { name: 'Pan integral', calories: 247, protein: 13, carbs: 41, fat: 3.6 },
    { name: 'Pan de centeno', calories: 259, protein: 9, carbs: 48, fat: 3.3 },
    { name: 'Pan de espelta', calories: 329, protein: 14.6, carbs: 63, fat: 2.5 },
    { name: 'Pan sin gluten', calories: 267, protein: 3.5, carbs: 56, fat: 2.8 },
    { name: 'Muesli', calories: 365, protein: 11, carbs: 67, fat: 6.7 },
    { name: 'Granola', calories: 471, protein: 10.6, carbs: 64.9, fat: 19.8 },
    { name: 'Tortitas de arroz', calories: 387, protein: 7.1, carbs: 81, fat: 3.4 },
    { name: 'Galletas integrales', calories: 441, protein: 8, carbs: 66, fat: 17 },
    { name: 'Crackers sin gluten', calories: 424, protein: 5, carbs: 78, fat: 9 }
  ];
  
  return usdaFoods.map((food, index) => ({
    id: `usda-default-${index}`,
    name: food.name,
    calories: food.calories,
    protein: food.protein,
    carbs: food.carbs,
    fat: food.fat,
    source: 'USDA'
  }));
};

// Expanded default Spanish foods list
export const getDefaultSpanishFoods = (): FoodItem[] => {
  const spanishFoods = [
    // Spanish staples
    { name: 'Jamón Ibérico', calories: 380, protein: 31, carbs: 0, fat: 29 },
    { name: 'Chorizo', calories: 455, protein: 24, carbs: 1.9, fat: 38 },
    { name: 'Tortilla Española', calories: 173, protein: 6.9, carbs: 7.5, fat: 13 },
    { name: 'Paella', calories: 156, protein: 5.5, carbs: 24, fat: 4.5 },
    { name: 'Gazpacho', calories: 34, protein: 0.8, carbs: 7, fat: 0.2 },
    { name: 'Aceite de Oliva', calories: 884, protein: 0, carbs: 0, fat: 100 },
    
    // Commercial products
    { name: 'Pan Bimbo', calories: 266, protein: 8, carbs: 49, fat: 3.5 },
    { name: 'Pan Bimbo Integral', calories: 265, protein: 11, carbs: 43, fat: 4.4 },
    { name: 'Tofu Mercadona', calories: 76, protein: 8, carbs: 1.9, fat: 4.8 },
    { name: 'Chocolate Valor 70%', calories: 598, protein: 7.9, carbs: 45.9, fat: 42.6 },
    { name: 'Chocolate Valor 85%', calories: 630, protein: 10.5, carbs: 31, fat: 53 },
    { name: 'Chocolate Valor con Almendras', calories: 570, protein: 8.5, carbs: 42, fat: 41 },
    { name: 'Chocolate Valor Blanco', calories: 560, protein: 6.5, carbs: 55, fat: 36 },
    { name: 'Chocolate Nestlé Extrafino', calories: 545, protein: 6.7, carbs: 58, fat: 32 },
    { name: 'Chocolate Nestlé Postres', calories: 520, protein: 7.2, carbs: 50, fat: 35 },
    { name: 'Chocolate Pacari 70%', calories: 590, protein: 9, carbs: 35, fat: 45 },
    
    // Vegetables
    { name: 'Pimiento Rojo', calories: 31, protein: 1, carbs: 6, fat: 0.3 },
    { name: 'Pimiento Verde', calories: 20, protein: 0.9, carbs: 4.6, fat: 0.2 },
    { name: 'Queso Manchego', calories: 412, protein: 26, carbs: 0.5, fat: 33.5 },
    { name: 'Arroz Blanco SOS', calories: 130, protein: 2.7, carbs: 28.2, fat: 0.3 },
    { name: 'Lentejas Luengo', calories: 116, protein: 9, carbs: 20, fat: 0.4 },
    { name: 'Garbanzos Cocidos Carretilla', calories: 135, protein: 7.2, carbs: 15, fat: 4.2 },
    { name: 'Garbanzos Secos Luengo', calories: 364, protein: 19, carbs: 61, fat: 6 },
    
    // Dairy and alternatives
    { name: 'Leche Desnatada Pascual', calories: 34, protein: 3.4, carbs: 4.8, fat: 0.1 },
    { name: 'Leche Semidesnatada Pascual', calories: 46, protein: 3.3, carbs: 4.8, fat: 1.6 },
    { name: 'Leche Entera Pascual', calories: 63, protein: 3.3, carbs: 4.8, fat: 3.6 },
    { name: 'Yogur Natural Danone', calories: 59, protein: 3.5, carbs: 4.7, fat: 3.3 },
    { name: 'Yogur Natural Hacendado', calories: 57, protein: 3.6, carbs: 5.5, fat: 2.5 },
    { name: 'Yogur Griego Hacendado', calories: 110, protein: 6, carbs: 5, fat: 7 },
    { name: 'Yogur de Soja Alpro', calories: 54, protein: 4, carbs: 6.5, fat: 1.8 },
    { name: 'Leche de Avena Alpro', calories: 46, protein: 0.3, carbs: 6.8, fat: 1.5 },
    { name: 'Leche de Almendra Alpro', calories: 24, protein: 0.5, carbs: 3, fat: 1.1 },
    { name: 'Leche de Soja Alpro', calories: 39, protein: 3, carbs: 2.5, fat: 1.8 },
    
    // Proteins
    { name: 'Atún en Conserva Calvo', calories: 132, protein: 29, carbs: 0, fat: 1 },
    { name: 'Hummus Hacendado', calories: 166, protein: 5, carbs: 8, fat: 12 },
    { name: 'Seitan El Granero', calories: 145, protein: 25, carbs: 9, fat: 2 },
    { name: 'Tofu Sedoso Sojasun', calories: 55, protein: 4.5, carbs: 2, fat: 3 },
    { name: 'Tofu Firme Taifun', calories: 144, protein: 16, carbs: 2, fat: 9 },
    { name: 'Tempeh Vegetalia', calories: 193, protein: 19, carbs: 9, fat: 11 },
    { name: 'Proteína de Soja Texturizada El Granero', calories: 338, protein: 52, carbs: 32, fat: 1 },
    
    // Vegetables
    { name: 'Lechuga Hacendado', calories: 15, protein: 1.4, carbs: 2.9, fat: 0.2 },
    { name: 'Tomate Hacendado', calories: 18, protein: 0.9, carbs: 3.9, fat: 0.2 },
    { name: 'Plátano Canario', calories: 89, protein: 1.1, carbs: 22.8, fat: 0.3 },
    { name: 'Manzana Golden', calories: 52, protein: 0.3, carbs: 14, fat: 0.2 },
    { name: 'Naranja Navelina', calories: 43, protein: 0.9, carbs: 8.3, fat: 0.1 },
    { name: 'Huevo Campero', calories: 155, protein: 13, carbs: 1.1, fat: 11 },
    
    // Meats and alternatives
    { name: 'Pollo (pechuga)', calories: 165, protein: 31, carbs: 0, fat: 3.6 },
    { name: 'Lomo de Cerdo', calories: 242, protein: 26, carbs: 0, fat: 16 },
    { name: 'Ternera (solomillo)', calories: 217, protein: 26, carbs: 0, fat: 12 },
    { name: 'Salmón', calories: 208, protein: 20, carbs: 0, fat: 13 },
    { name: 'Hamburguesa Vegetal Heura', calories: 190, protein: 16, carbs: 6, fat: 12 },
    { name: 'Hamburguesa Vegetal Garden Gourmet', calories: 170, protein: 15, carbs: 5, fat: 10 },
    { name: 'Nuggets Vegetales Garden Gourmet', calories: 220, protein: 11, carbs: 15, fat: 13 },
    
    // Fruits
    { name: 'Aguacate', calories: 160, protein: 2, carbs: 8.5, fat: 14.7 },
    { name: 'Nueces', calories: 654, protein: 15, carbs: 14, fat: 65 },
    { name: 'Cebolla', calories: 40, protein: 1.1, carbs: 9.3, fat: 0.1 },
    { name: 'Ajo', calories: 149, protein: 6.4, carbs: 33, fat: 0.5 },
    { name: 'Zanahoria', calories: 41, protein: 0.9, carbs: 9.6, fat: 0.2 },
    { name: 'Calabacín', calories: 17, protein: 1.2, carbs: 3.1, fat: 0.3 },
    { name: 'Berenjena', calories: 25, protein: 1, carbs: 6, fat: 0.2 },
    { name: 'Pepino', calories: 15, protein: 0.7, carbs: 3.6, fat: 0.1 },
    { name: 'Pera Conferencia', calories: 58, protein: 0.4, carbs: 15.5, fat: 0.1 },
    { name: 'Sandía', calories: 30, protein: 0.6, carbs: 7.6, fat: 0.2 },
    { name: 'Melón', calories: 34, protein: 0.8, carbs: 8, fat: 0.2 },
    
    // Berries
    { name: 'Fresa', calories: 33, protein: 0.7, carbs: 7.7, fat: 0.3 },
    { name: 'Arándanos', calories: 57, protein: 0.7, carbs: 14, fat: 0.3 },
    { name: 'Frambuesas', calories: 52, protein: 1.2, carbs: 11.9, fat: 0.7 },
    { name: 'Moras', calories: 43, protein: 1.4, carbs: 9.6, fat: 0.5 },
    { name: 'Kiwi', calories: 61, protein: 1.1, carbs: 14, fat: 0.5 },
    { name: 'Piña', calories: 50, protein: 0.5, carbs: 13, fat: 0.1 },
    { name: 'Mango', calories: 60, protein: 0.8, carbs: 15, fat: 0.4 },
    
    // Vegetables
    { name: 'Puerro', calories: 61, protein: 1.5, carbs: 14, fat: 0.3 },
    { name: 'Espinacas', calories: 23, protein: 2.9, carbs: 3.6, fat: 0.4 },
    { name: 'Brócoli', calories: 34, protein: 2.8, carbs: 6.6, fat: 0.4 },
    { name: 'Coliflor', calories: 25, protein: 1.9, carbs: 5, fat: 0.1 },
    { name: 'Alcachofa', calories: 47, protein: 3.3, carbs: 10, fat: 0.2 },
    { name: 'Espárragos', calories: 20, protein: 2.2, carbs: 3.9, fat: 0.2 },
    { name: 'Champiñones', calories: 22, protein: 3.1, carbs: 3.3, fat: 0.3 },
    
    // Nuts and dried fruits
    { name: 'Pistacho', calories: 560, protein: 20, carbs: 28, fat: 45 },
    { name: 'Avellanas', calories: 628, protein: 14.9, carbs: 16.7, fat: 60.8 },
    { name: 'Almendras Hacendado', calories: 606, protein: 21, carbs: 6.5, fat: 52 },
    { name: 'Anacardos Hacendado', calories: 553, protein: 18, carbs: 30.2, fat: 43.8 },
    { name: 'Nueces Peladas Hacendado', calories: 650, protein: 15, carbs: 14, fat: 65 },
    { name: 'Dátiles', calories: 282, protein: 2.5, carbs: 75, fat: 0.4 },
    { name: 'Ciruelas Pasas', calories: 240, protein: 2.2, carbs: 63.9, fat: 0.4 },
    { name: 'Orejones', calories: 241, protein: 3.4, carbs: 62.6, fat: 0.5 },
    
    // Grains
    { name: 'Quinoa El Granero', calories: 368, protein: 14, carbs: 64, fat: 6 },
    { name: 'Arroz Integral SOS', calories: 350, protein: 7, carbs: 77.6, fat: 0.9 },
    { name: 'Avena Integral Quaker', calories: 375, protein: 13, carbs: 67, fat: 7 },
    { name: 'Copos de Avena Hacendado', calories: 371, protein: 12, carbs: 66, fat: 7 },
    { name: 'Cuscús', calories: 376, protein: 12.8, carbs: 77.4, fat: 0.6 },
    { name: 'Bulgur', calories: 342, protein: 12.3, carbs: 75.9, fat: 1.3 },
    
    // Commercial products
    { name: 'Maíz Dulce Hacendado', calories: 96, protein: 3.5, carbs: 18, fat: 2 },
    { name: 'Cacao en Polvo Cola Cao', calories: 376, protein: 7.5, carbs: 78, fat: 4.5 },
    { name: 'Cacao Puro Valor', calories: 310, protein: 23, carbs: 28, fat: 11 },
    { name: 'Galletas María Fontaneda', calories: 440, protein: 7, carbs: 74, fat: 14 },
    { name: 'Galletas Oreo', calories: 480, protein: 5, carbs: 71, fat: 20 },
    { name: 'Galletas Digestive Gullon Sin Azúcar', calories: 470, protein: 6, carbs: 65, fat: 22 },
    { name: 'Patatas Fritas Lays', calories: 536, protein: 6.4, carbs: 51, fat: 34 },
    { name: 'Nachos Doritos', calories: 480, protein: 7, carbs: 66, fat: 23 },
    { name: 'Aceitunas Verdes El Serpis', calories: 150, protein: 0.8, carbs: 1, fat: 15.3 },
    { name: 'Aceitunas Negras Hacendado', calories: 245, protein: 1.5, carbs: 4, fat: 25 },
    { name: 'Tomate Frito Orlando', calories: 94, protein: 1.5, carbs: 9, fat: 6 },
    { name: 'Tomate Natural Hacendado', calories: 22, protein: 1, carbs: 3.5, fat: 0.3 },
    
    // Corn products (Maíz)
    { name: 'Maíz Dulce en Lata Hacendado', calories: 83, protein: 2.2, carbs: 16, fat: 1.4 },
    { name: 'Palomitas de Maíz Hacendado', calories: 375, protein: 12, carbs: 74, fat: 4.3 },
    { name: 'Tortitas de Maíz Bicentury', calories: 380, protein: 8, carbs: 80, fat: 3 },
    { name: 'Nachos de Maíz El Sabor', calories: 456, protein: 7.5, carbs: 70, fat: 22 },
    { name: 'Tacos Old El Paso', calories: 290, protein: 8, carbs: 57, fat: 3 },
    { name: 'Harina de Maíz PAN', calories: 365, protein: 8, carbs: 79, fat: 1 },
    { name: 'Tortillas de Maíz Old El Paso', calories: 218, protein: 5.8, carbs: 44, fat: 2.9 },
    
    // Chocolate varieties
    { name: 'Chocolate Valor 70% Negro', calories: 520, protein: 9, carbs: 35, fat: 45 },
    { name: 'Chocolate Valor 85% Negro', calories: 550, protein: 11, carbs: 20, fat: 53 },
    { name: 'Chocolate Valor Negro con Naranja', calories: 525, protein: 8, carbs: 40, fat: 43 },
    { name: 'Chocolate Valor Negro con Almendras', calories: 540, protein: 10, carbs: 35, fat: 45 },
    { name: 'Chocolate Valor Blanco', calories: 560, protein: 6, carbs: 55, fat: 36 },
    { name: 'Chocolate Nestlé Extrafino', calories: 530, protein: 7, carbs: 55, fat: 32 },
    { name: 'Chocolate Nestlé con Leche y Avellanas', calories: 535, protein: 8, carbs: 53, fat: 33 },
    { name: 'Chocolate Nestlé Blanco', calories: 550, protein: 6, carbs: 58, fat: 33 },
    { name: 'Chocolate Lindt 70%', calories: 530, protein: 9, carbs: 35, fat: 45 },
    { name: 'Chocolate Lindt 85%', calories: 550, protein: 11, carbs: 20, fat: 53 },
    { name: 'Chocolate Lindt 90%', calories: 580, protein: 12, carbs: 14, fat: 55 },
    { name: 'Chocolate Lindt Naranja Intensa', calories: 540, protein: 8, carbs: 40, fat: 45 },
    { name: 'Chocolate Milka', calories: 530, protein: 6, carbs: 57, fat: 30 },
    { name: 'Chocolate Milka con Oreo', calories: 520, protein: 5, carbs: 60, fat: 28 },
    { name: 'Chocolatinas Kinder Bueno', calories: 572, protein: 8, carbs: 51, fat: 37 },
    { name: 'Ferrero Rocher', calories: 603, protein: 8, carbs: 40, fat: 46 },
    
    // Various brands of basic foods
    { name: 'Leche de Almendra Almond Breeze', calories: 24, protein: 0.5, carbs: 3, fat: 1.1 },
    { name: 'Leche de Almendra Alpro', calories: 24, protein: 0.5, carbs: 3, fat: 1.1 },
    { name: 'Leche de Almendra Hacendado', calories: 23, protein: 0.6, carbs: 2.9, fat: 1.1 },
    { name: 'Leche de Avena Oatly', calories: 46, protein: 1, carbs: 6.6, fat: 1.5 },
    { name: 'Tofu Taifun Natural', calories: 144, protein: 16, carbs: 2, fat: 9 },
    { name: 'Tofu Natursoy', calories: 135, protein: 15, carbs: 2, fat: 8 },
    { name: 'Tofu Hacendado', calories: 140, protein: 15.5, carbs: 2, fat: 8.5 },
    { name: 'Soja Texturizada Fina', calories: 338, protein: 52, carbs: 32, fat: 1 },
    { name: 'Soja Texturizada Gruesa', calories: 338, protein: 52, carbs: 32, fat: 1 },
  ];
  
  return spanishFoods.map((food, index) => ({
    id: `off-es-default-${index}`,
    name: food.name,
    calories: food.calories,
    protein: food.protein,
    carbs: food.carbs,
    fat: food.fat,
    source: 'Open Food Facts'
  }));
};
